var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSortArrowsInv(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.299657 12.1522C0.693749 11.7652 1.32689 11.771 1.71381 12.1651L3.70023 14.1883L5.68664 12.1651C6.07357 11.771 6.7067 11.7652 7.1008 12.1522C7.49489 12.5391 7.5007 13.1722 7.11377 13.5663L4.41379 16.3163C4.22576 16.5078 3.96862 16.6157 3.70023 16.6157C3.43183 16.6157 3.1747 16.5078 2.98666 16.3163L0.286678 13.5663C-0.100246 13.1722 -0.0944351 12.5391 0.299657 12.1522Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.10074 4.46356C6.70665 4.85049 6.07351 4.84468 5.68658 4.45059L3.70013 2.42736L1.71368 4.45059C1.32676 4.84468 0.693619 4.85049 0.29953 4.46356C-0.0945596 4.07664 -0.100367 3.4435 0.286559 3.04941L2.98657 0.299408C3.17461 0.107891 3.43174 -3.53352e-07 3.70013 -3.29454e-07C3.96853 -3.05556e-07 4.22566 0.107891 4.4137 0.299408L7.11371 3.04941C7.50063 3.4435 7.49483 4.07664 7.10074 4.46356Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortArrowsInv);
export default __webpack_public_path__ + "static/media/sort-arrows-inv.af81c5887cb6b5615879532f33d9f938.svg";
export { ForwardRef as ReactComponent };